import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BuscaService } from 'src/app/services/busca.service';
import { HistoricoEscolar } from 'src/app/models/historicoEscolar';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-diploma',
    templateUrl: './diploma.component.html',
    styleUrls: ['./diploma.component.scss'],
    standalone: false
})
export class DiplomaComponent implements OnInit {

  pdf: any;
  downloadLinkXML: SafeResourceUrl;
  downloadLinkRVHE: SafeResourceUrl;

  xmlFile: string;
  codigo: string = '';

  nomeArquivoXML: string = `historico_escolar_${new Date().getDate() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getFullYear()}.xml`;
  nomeArquivoRVHE: string = `historico_escolar_${new Date().getDate() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getFullYear()}.pdf`;

  resultadoBusca: HistoricoEscolar = null;
  erro: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _busca: BuscaService,
    private domSanitizer: DomSanitizer,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.spinner.show();

    this.route.paramMap.subscribe(paramMap => {
      this.codigo = paramMap.get('id');
    });

    this.buscar();
  }

  buscar() {
    this._busca.getHistorico(this.codigo, '').subscribe(response => {
      if (response.length > 0) {
        this.resultadoBusca = response[0];

        // Printa o XML na tela
        this.pdf = this.getPDF(this.resultadoBusca.imgRVHE);

        // Link para download do arquivo XML
        this.downloadLinkXML = this.domSanitizer.bypassSecurityTrustResourceUrl('data:application/octet-stream;base64,' + this.resultadoBusca.codXMLPublico);

        // Link para download do arquivo PDF
        this.downloadLinkRVHE = this.domSanitizer.bypassSecurityTrustResourceUrl(this.pdf);
      } else {
        this.erro = true;
        this.router.navigate(['/hed']);
      }

      this.spinner.hide();
    }, error => {
      this.spinner.hide();
      this.erro = true;
      this.router.navigate(['/hed']);

      if (error.status === 404) {
        this.resultadoBusca = null;
      } else {
        console.log(error);
      }
    });
  }

  getPDF(pdf: string) {
    const byteArray = new Uint8Array(atob(pdf).split('').map(char => char.charCodeAt(0)));
    let blob = new Blob([byteArray], {
      type: 'data:application/pdf'
    });

    return URL.createObjectURL(blob);
  }

}
